import React from 'react';
import Loader from 'components/Loader';
import Documento from './Documento';
import Itens from './Itens';
import Equipamentos from './Equipamentos';
import Financeiro from './Financeiro';
import Transportes from './Transportes';
import MDFE from './MDFE';
import Registros from './Registros';
import FormaDeEnvio from './FormaDeEnvio';
import Transmissão from './Transmissão';
import Cartas from './Cartas';

const Tabs = ({ tab, getLoading, ...props }) => {
  if (getLoading) {
    return <Loader />;
  }
  switch (tab) {
    case 0:
      return <Documento {...props} />;
    case 1:
      return <Itens {...props} />;
    case 2:
      return <Equipamentos {...props} />;
    case 3:
      return <Financeiro {...props} />;
    case 4:
      return <Transportes {...props} />;
    case 5:
      return <MDFE {...props} />;
    case 6:
      return <Registros {...props} />;
    case 7:
      return <FormaDeEnvio {...props} />;
    case 8:
      return <Transmissão {...props} />;
    case 9:
      return <Cartas {...props} />;
    default:
      return null;
  }
};

export default Tabs;
